import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { type FormTramiteValues } from '@/interfaces/model/don.interface';

import DatosFirma from './componentes/datosFirma';
import ModalRevisionFirma from './ModalRevisionFirma';

type FirmaSolicitudProps = {
	readonly title: string;
	readonly reload?: () => void;
};

const FirmaSolicitud = ({ title, reload }: FirmaSolicitudProps) => {
	const { watch } = useFormContext<FormTramiteValues>();

	const [isShowingDetalle, setIsShowingDetalle] = useState(false);
	const protocolo = watch('protocolo');
	const idTramite = watch('id' as any); 

	const handleViewDetalle = () => {
		setIsShowingDetalle(true);
		reload?.();
	};

	const handleOnSubmit = () => {
		setIsShowingDetalle(false);
		reload?.();
	};

	return (
		<>
			<div className="o-splitter u-mb-16">
				<h4 className="c-pnp-heading-h4">{title}</h4>
			</div>

			<DatosFirma
				hasAcciones 
				protocolo={protocolo}
				onClickVerDetalle={() => {
					handleViewDetalle();
				}} 
			/>

			<ModalRevisionFirma
				isOpen={isShowingDetalle}
				protocolo={protocolo}
				idTramite={idTramite}
				onClose={() => setIsShowingDetalle(false)}
				onSubmit={() => {
					handleOnSubmit();
				}}
			/>
		</>
	);
};

export default FirmaSolicitud;